import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
/*
 * regenerator-runtime is required for e-reader component
 * and should be defined globally to be available at runtime in the production code
 * */
import 'regenerator-runtime/runtime'

import Root from 'root'
import store from 'app/store'

const container = document.getElementById('root')

render(
  <Provider store={store}>
    <Root />
  </Provider>,
  container
)
